import React, { useEffect, useState } from "react";
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import Stack from '@mui/material/Stack';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
function OptionM({ onInputChange, year, month }){

    const today = new Date();
    const Datemax = today.getMonth() === 0 ? today.getFullYear() - 1 + '-' + 12 : today.getFullYear() + '-' + today.getMonth()
    const [value, setValue] = useState(month === 0 || year === 0 ? dayjs(`${today.getFullYear()}-${today.getMonth() + 1}-01`) : dayjs(`${year}-${month}-01`));


    useEffect(() => {

    }, [])

  return (
   
      <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Stack spacing={3}>
              <MobileDatePicker
                  disableFuture
                  label="Select Month and Year"
                  openTo="year"
                  views={['year', 'month']}
                  value={value}
                  onChange={(newValue) => {
                      onInputChange(newValue.$M + 1, newValue.$y)
                      setValue(newValue);
                      sessionStorage.setItem("ToMonth", newValue.$M + 1)
                      sessionStorage.setItem("ToYear", newValue.$y)
                  }}
                  minDate={dayjs(`${year}-${month}-01`)}
                  maxDate={dayjs(Datemax)}
                  renderInput={(params) => <TextField sx={{ width: 200 }} onKeyDown={(evt) => evt.preventDefault()}  {...params} />}
              />
          </Stack>
      </LocalizationProvider>

         
  );
};

export default OptionM;
